import { render } from "./DefineTerm.vue?vue&type=template&id=145f4c50&ts=true"
import script from "./DefineTerm.vue?vue&type=script&lang=ts"
export * from "./DefineTerm.vue?vue&type=script&lang=ts"

import "./DefineTerm.vue?vue&type=style&index=0&id=145f4c50&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__